import { Injectable } from '@angular/core';
import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse, HttpRequest, HttpHandler, HttpHeaders } from '@angular/common/http';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import {environment} from '../../environments/environment';
import { ToastrServiceLocal } from './toast/toastr.service';
@Injectable({
  providedIn: 'root'
})
export class InterceptorService {
  public token:string;
  public MFX_01:string;
  constructor(private router: Router, private loginS: LoginService,public _toast: ToastrServiceLocal,) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    this.MFX_01 = localStorage.getItem("MFX_01")
    this.token = localStorage.getItem(environment.tokenLocal);

    if (this.token == null) {
      this.token = '';
    }
 // Obtener la ruta actual
 const currentRoute = this.router.url.split('?')[0]; // Eliminar query params si los hay
 const mainRoute = currentRoute.split('/').slice(0, 2).join('/'); // Extrae la primera parte de la URL hasta /<segmento>
 const login = this.router.url;
//  console.log("aa",mainRoute)
if (this.token !== localStorage.getItem(environment.tokenLocal) && (mainRoute !== '/ofertaAcademica' && mainRoute !== '/inicio' && mainRoute !== '/fichaAdmision' && mainRoute !== '/validar' && login !== '/estudiante/login' && login !== '/login' && login !== '/dsa/login' && login !== '/postulante/login')) {

  console.log("entro aqui")
  this.loginS.cerrarSesion();
      this.router.navigateByUrl('/inicio');
      this._toast.mensajeWarning('Ha expirado la sesión', 'Mensaje', {});

    }

if (!this.token  && (mainRoute !== '/ofertaAcademica' && mainRoute !== '/inicio' && mainRoute !== '/fichaAdmision' && mainRoute !== '/validar' && login !== '/estudiante/login' && login !== '/login' && login !== '/dsa/login' && login !== '/postulante/login') ) {
 console.log("entro aqui")
  this.loginS.cerrarSesion();
      this.router.navigateByUrl('/inicio');
      this._toast.mensajeWarning('Ha expirado la sesión', 'Mensaje', {});

    }
    let request = req;

    if(req.body){
      if(req.body.idSistema === undefined){
        req.body.idSistema = environment?.idSistema || '';
      }
    }
    if (this.token) {
      request = req.clone({
        setHeaders: {
          authorization: 'Bearer ' + this.token
        }
      });
      
    }
    if (this.MFX_01 === null && (mainRoute !== '/ofertaAcademica' && mainRoute !== '/inicio' && mainRoute !== '/fichaAdmision' && mainRoute !== '/validar' && login !== '/estudiante/login' && login !== '/login' && login !== '/dsa/login' && login !== '/postulante/login' && login !== '/dashboard')) {
      this.loginS.cerrarSesion();
      this.router.navigateByUrl('/inicio');

    }


    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          this.loginS.cerrarSesion();
          this.router.navigateByUrl('/inicio');
          this._toast.mensajeWarning('Ha expirado la sesión', 'Mensaje', {});
        }

        return throwError(err);

      })
    );
  }
}
